const $ = jQuery.noConflict();

'use strict';

const SelectedFiltersToggle = {
	/**
	 * @description Cache DOM elements
	 */
	$selectedFilters: $('.js-selected-filters'),
	$toggleButton: $('.js-selected-filters-toggle'),
	$hiddenCount: $('.js-selected-filters-hidden'),
	$filterTags: $('.pill'),

	init: function() {
		this.bindEvents();
		this.updateHiddenCount();
	},

	/**
	 * Bind Events
	 */
	bindEvents: function() {
		this.$toggleButton.on('click', this.toggleFilters.bind(this));
	},

	/**
	 * Toggle visibility of hidden filters and add class to selected-filters
	 */
	toggleFilters: function() {
		this.$selectedFilters.toggleClass('is-expanded');
		this.updateToggleButtonText();
	},

	/**
	 * Update toggle button text
	 */
	updateToggleButtonText: function() {
		const isExpanded = this.$selectedFilters.hasClass('is-expanded');
		this.$toggleButton.text(isExpanded ? `-${this.getHiddenCount()}` : `+${this.getHiddenCount()}`);
	},

	/**
	 * Count and update hidden filters
	 */
	updateHiddenCount: function() {
		const hiddenCount = this.getHiddenCount();
		this.$hiddenCount.text(hiddenCount);
	},

	/**
	 * Get number of hidden filters
	 */
	getHiddenCount: function() {
		return this.$filterTags.slice(5).length;
	},
};

export default SelectedFiltersToggle;
